import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcAutoDelete16 } from '@gem/icons';

import { Group } from 'STORE/Groups/Group';

import { Avatar, AvatarTypes } from '../Avatar';
import { AvatarWithFullScreen } from '../AvatarWithFullScreen/AvatarWithFullScreen';

interface IGroupAvatarProps {
  className?: string;
  group: Group | null;
  type?: AvatarTypes;
  isShowOnlineIndicator?: boolean;
  hasLockIcon?: boolean;
  isShowAutoCleanupIndicator?: boolean;
  withFullScreen?: boolean;
}

export const GroupAvatar: FC<IGroupAvatarProps> = observer(
  ({
    className,
    group,
    type = AvatarTypes.Round_10,
    isShowOnlineIndicator,
    hasLockIcon,
    isShowAutoCleanupIndicator,
    withFullScreen,
  }) => {
    const badge =
      isShowAutoCleanupIndicator && !!group?.ttlPeriodMs
        ? {
            Icon: IcAutoDelete16,
          }
        : undefined;

    const avatar = (
      <Avatar
        className={!withFullScreen ? className : undefined}
        type={type}
        url={group?.avatarUrl}
        title={group?.avatarTitle || undefined}
        backgroundColorIndex={group?.avatarColorIndex}
        isOnline={isShowOnlineIndicator && group?.isOnlineOpponent}
        hasLockIcon={hasLockIcon}
        badge={badge}
      />
    );

    if (withFullScreen && !group?.isSavedMessages) {
      return (
        <AvatarWithFullScreen
          className={className}
          url={group?.avatarUrl || undefined}
        >
          {avatar}
        </AvatarWithFullScreen>
      );
    }

    return avatar;
  }
);
